<template>
  <div>
    <div class="row">
      <div v-if="availableYears.length > 0" class="col-lg-3 col-md-6 col-sm-6">
        <label>{{this.$t('dokumentet.filtro')}}</label> 
        <div>
          <select
            v-model="filters.selectYear"
            @change="fetchDocuments"
            class="form-select"
            :placeholder="$t('dokumentet.zgjedhvitin')"
          >
            <option value="">{{this.$t('dokumentet.showall')}}</option>
            <option v-for="year in availableYears" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div v-if="filters.selectYear === '' && availableYears.length > 0" class="mt-2 text-muted" style="font-size: 0.95em;">
          <span>{{ minYear }} - {{ maxYear }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <br />
        <button
          type="submit"
          @click="fetchDocuments"
          class="btn btn-secondary btn-block"
        >{{this.$t('dokumentet.search')}}
           <i class="bi bi-search"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useDocumentStore } from '@/store/DocumentStore/documentStore';

export default {
  props: {
    modelValue: Object,
    documentTypeId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue', 'apply-filters', 'update:availableYears'],
  data() {
    return {
      availableYears: [],
      documentStore: null,
    };
  },
  computed: {
    filters: {
      get() {
        return (
          this.modelValue || {
            selectYear: null,
          }
        );
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    minYear() {
      return this.availableYears.length ? Math.min(...this.availableYears) : '';
    },
    maxYear() {
      return this.availableYears.length ? Math.max(...this.availableYears) : '';
    },
  },
  watch: {
    documentTypeId: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchYearsFromApi();
        }
      }
    }
  },
  async mounted() {
    this.documentStore = useDocumentStore();
    await this.fetchYearsFromApi();
    // Set default year to current year if available, otherwise the newest year
    const currentYear = new Date().getFullYear();
    if (this.availableYears.includes(currentYear)) {
      this.filters.selectYear = currentYear;
    } else if (this.availableYears.length > 0) {
      this.filters.selectYear = this.availableYears[0];
    }
    this.fetchDocuments();
  },
  methods: {
    async fetchYearsFromApi() {
      try {
        const response = await this.documentStore.getYears({
          documentTypeId: this.documentTypeId,
        });
        this.availableYears = Array.isArray(response.years)
          ? response.years.sort((a, b) => b - a)
          : [];
        this.$emit('update:availableYears', this.availableYears);
      } catch (error) {
        console.error('Failed to fetch years:', error);
        this.availableYears = [];
        this.$emit('update:availableYears', []);
      }
    },
    fetchDocuments() {
      this.$emit('apply-filters', this.filters);
    },
  },
};
</script>

<style scoped>
.form-select {
  background-color: transparent;
  border: 1px solid #ced4da;
  box-shadow: none;
  max-height: 200px;
  overflow-y: auto;
}
.form-select:focus {
  border-color: #ced4da;
  box-shadow: none;
}
label {
  font-weight: 500;
  margin-bottom: 0.25rem;
}
</style>